import { render, staticRenderFns } from "./H5RetainModal.vue?vue&type=template&id=51ef9078&scoped=true&"
import script from "./H5RetainModal.vue?vue&type=script&lang=js&"
export * from "./H5RetainModal.vue?vue&type=script&lang=js&"
import style0 from "./H5RetainModal.vue?vue&type=style&index=0&id=51ef9078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef9078",
  null
  
)

export default component.exports